import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import { ReleasePhaseConfig } from '#utils/flags/records/ReleasePhaseConfig';
import type { Rollout } from '#utils/flags/records/Rollout';
import { createRollout } from '#utils/flags/records/Rollout';

export type FallthroughProps = {
  measuredRolloutConfig?: ReleasePhaseConfig;
} & { variation?: number; rollout?: Rollout };

export class Fallthrough extends Record<FallthroughProps>({
  rollout: undefined,
  variation: undefined,
  measuredRolloutConfig: undefined,
}) {
  toRep() {
    return fromJS(this.toJSON()).withMutations((map: Fallthrough) => {
      map.get('rollout') === null || map.get('rollout') === undefined
        ? map.remove('rollout')
        : map.update('rollout', (r) => r?.toRep());
      (map.get('variation') === null || map.get('variation') === undefined) && map.remove('variation');
    });
  }
  hasNonUserRollout() {
    return !!this.rollout && this.rollout?.hasNonUserContext();
  }

  hasVariationOrRollout() {
    return this.variation !== undefined || (this.rollout && !this.rollout?.experimentAllocation);
  }
}

export function createFallthrough(props: CreateFunctionInput<Fallthrough> = {}) {
  const fallthrough = props instanceof Fallthrough ? props : new Fallthrough(fromJS(props));
  return fallthrough.withMutations((map) => {
    map.update('rollout', (r) => (r ? createRollout(r) : r));
    map.update('measuredRolloutConfig', (m) => (m ? new ReleasePhaseConfig(m) : m));
  });
}
